const CONTINUE_URL_KEY = 'continueUrl';
export function getCachedContinueUrl() {
    const urlData = JSON.parse(sessionStorage.getItem(CONTINUE_URL_KEY));
    if (urlData && urlData.validTo > Date.now()) {
        return urlData.continue;
    }

    sessionStorage.removeItem(CONTINUE_URL_KEY);
    return null;
}

export function cacheContinueUrl(continueUrl) {
    const urlData = {
        continue: continueUrl,
        validTo: Date.now() + 300000
    }
    sessionStorage.setItem(CONTINUE_URL_KEY, JSON.stringify(urlData));
}